<div>
  <img [src]="mercuryLogoPath" class="mercury-logo mb-5" alt="Mercury Logo" />
  @if (!isCommonPage) {
    <div class="jumbo-medium text-primary mb-5">Login to Mercury Portal</div>
  }

  @if (isCommonPage) {
    <div>
      <div (click)="navigateToBookShipment()" class="button-container mb-5">
        <div class="jumbo-medium text-primary flex flex-row align-items-center">
          Ship as a Guest <i class="icon icon-bx-chevron-right ml-auto"></i>
        </div>
        <div class="subtitle-small text-placeholder">
          Ship without an account! As a guest, you'll pay upfront and complete
          your shipment quickly—no login required.
        </div>
      </div>
      <div class="jumbo-medium text-primary mb-5">or Login to Ship</div>
    </div>
  }

  <form
    [formGroup]="loginForm"
    (submit)="enableRecaptcha ? submitRequestWithCaptcha() : login()"
    class="flex flex-column gap-3"
  >
    <div class="flex flex-column gap-2">
      <div class="field-label-medium text-tertiary">
        <label for="emailInput">User Email</label>
      </div>
      <div class="p-fluid">
        <input
          data-hj-allow
          pInputText
          formControlName="email"
          type="email"
          id="emailInput"
          aria-describedby="emailHelp"
          placeholder="Enter User Email"
        />
        <me-form-validation-message
          controlName="email"
          label="Email"
        ></me-form-validation-message>
      </div>
    </div>
    <div class="flex flex-column gap-2">
      <div class="field-label-medium text-tertiary">
        <label for="passwordInput">Password</label>
      </div>
      <div class="p-fluid">
        <p-password
          [feedback]="false"
          [toggleMask]="true"
          formControlName="password"
          id="passwordInput"
          placeholder="Password"
          class="p-password p-component p-inputwrapper p-input-icon-right"
        ></p-password>
        <me-form-validation-message
          controlName="password"
          label="Password"
        ></me-form-validation-message>
      </div>
    </div>
    <div class="flex flex-row justify-content-end">
      <div
        class="text-right field-label-medium color-base-blue-blue-500 cursor-pointer"
        routerLink="/forgot-password"
      >
        Forgot password?
      </div>
    </div>
    <div class="mb-3 mt-3">
      <button
        pButton
        type="submit"
        class="p-button-primary w-full button-text-medium"
        [loading]="!!(formSubmitted | async)"
      >
        <span pButtonLabel>Login</span>
      </button>
    </div>
    <div class="text-secondary field-label-medium text-center">
      Don't have an account?
    </div>
    <div class="">
      <button
        pButton
        type="button"
        class="p-button-secondary w-full button-text-medium"
        [loading]="!!(formSubmitted | async)"
        (click)="navigateToRequestAccount()"
      >
        <span pButtonLabel>Request Account</span>
      </button>
    </div>
  </form>
</div>

@if (enableRecaptcha) {
  <re-captcha
    #captchaRef
    (resolved)="resolved($event)"
    [siteKey]="captchaPublicSiteKey"
    size="invisible"
  ></re-captcha>
}
